import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { EmojiClickData } from "emoji-picker-react";
import { IncidentFormObject } from "utils/types/generalTypes";
import { LocationObj } from "../site/site";

export type IncidentFormState = {
    incidentGroup: IncidentFormObject[];
    incidentLocation: LocationObj;
    emojiIncidentId: number;
    gifIncidentId: number;
    mapIncidentId: number;
    emojiModalPosition: { left: number; top: number };
    openMapModal: boolean;
    openRules: boolean;
};

export type AddEmojiActionObject = {
    emoji: EmojiClickData;
    id: number;
};

const initialState: IncidentFormState = {
    incidentGroup: [
        {
            id: 1,
            type: "incident",
            text: "",
            mediaType: null,
            isValid: false
        }
    ],
    incidentLocation: {
        lat: 0,
        lng: 0,
        address: ""
    },
    emojiIncidentId: 0,
    gifIncidentId: 0,
    mapIncidentId: 0,
    emojiModalPosition: { left: 0, top: 0 },
    openMapModal: false,
    openRules: false
};

export const incidentFormSlice = createSlice({
    name: "incidentForm",
    initialState,
    reducers: {
        rUpdateIncident: (state, action: PayloadAction<IncidentFormObject>) => {
            const tempGroup = state.incidentGroup.map((p) => {
                if (p.id == action.payload.id) {
                    return action.payload;
                } else {
                    return p;
                }
            });
            state.incidentGroup = tempGroup;
        },
        addIncidentEmoji: (state, action: PayloadAction<EmojiClickData>) => {
            const tempGroup = state.incidentGroup.map((p) => {
                if (p.id == state.emojiIncidentId) {
                    return {
                        ...p,
                        text: `${p.text} ${action.payload.emoji}`
                    };
                } else {
                    return p;
                }
            });
            state.incidentGroup = tempGroup;
        },
        setEmojiIncidentId: (state, action: PayloadAction<number>) => {
            state.emojiIncidentId = action.payload;
        },
        setGifIncidentId: (state, action: PayloadAction<number>) => {
            state.gifIncidentId = action.payload;
        },
        addIncidentGif: (state, action: PayloadAction<string>) => {
            const tempGroup = state.incidentGroup.map((p) => {
                if (p.id == state.gifIncidentId) {
                    const tempP: IncidentFormObject = {
                        ...p,
                        gif: action.payload,
                        mediaType: "gif",
                        images: undefined,
                        video: undefined
                    };
                    return tempP;
                } else {
                    return p;
                }
            });
            state.incidentGroup = tempGroup;
        },
        rRemoveIncident: (state, action: PayloadAction<number>) => {
            state.incidentGroup = state.incidentGroup.filter(
                (p) => p.id != action.payload
            );
        },
        setEmojiModalPostion: (
            state,
            action: PayloadAction<{ left: number; top: number }>
        ) => {
            state.emojiModalPosition = action.payload;
        },
        addIncident: (state) => {
            const incidentId =
                state.incidentGroup[state.incidentGroup.length - 1].id + 1;
            const newIncident: IncidentFormObject = {
                id: incidentId,
                type: "incident",
                text: "",
                mediaType: null,
                isValid: false
            };
            state.incidentGroup = [...state.incidentGroup, newIncident];
        },
        openMapModal: (state, action: PayloadAction<number>) => {
            state.mapIncidentId = action.payload;
            state.openMapModal = true;
        },
        closeMapModal: (state) => {
            state.openMapModal = false;
        },
        addLocationToIncident: (state, action: PayloadAction<string>) => {
            const tempGroup = state.incidentGroup.map((i) => {
                if (i.id == state.mapIncidentId) {
                    const tempInc: IncidentFormObject = {
                        ...i,
                        location: action.payload
                    };
                    return tempInc;
                } else {
                    return i;
                }
            });
            state.incidentGroup = tempGroup;
        },
        openRulesModal: (state) => {
            state.openRules = true;
        },
        closeRulesModal: (state) => {
            state.openRules = false;
        },
        setIncidentLocation: (state, action: PayloadAction<LocationObj>) => {
            state.incidentLocation = action.payload;
        }
    }
});

export const {
    rUpdateIncident,
    addIncidentEmoji,
    setEmojiIncidentId,
    setGifIncidentId,
    addIncidentGif,
    rRemoveIncident,
    setEmojiModalPostion,
    addIncident,
    openMapModal,
    closeMapModal,
    addLocationToIncident,
    openRulesModal,
    closeRulesModal,
    setIncidentLocation
} = incidentFormSlice.actions;

export default incidentFormSlice.reducer;
